import { useShowSuccess, useShowError } from 'hooks/useToast'
import { usePromoteInventoryLocationToDefaultMutation } from '../../../../graphql'
import { InventoryLocation } from 'inventory-web'

export default function useSetDefaultInventoryLocation( updateAfterEdit?: ( updatedInventoryLocation: InventoryLocation, clearOtherDefaults?: boolean ) => void ) {
	const [ updateToDefault ] = usePromoteInventoryLocationToDefaultMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( inventoryLocationId: string ) => {
		const result = await updateToDefault( { variables: { inventoryLocationId } } )

		if ( updateAfterEdit && result.data?.promoteInventoryLocationToDefault?.inventoryLocation ) {
			updateAfterEdit( result.data.promoteInventoryLocationToDefault.inventoryLocation, true )
		}

		if ( result.data?.promoteInventoryLocationToDefault?.success ) {
			showSuccess( `promoteInventoryLocationToDefaultSuccess${Date.now()}`, result.data?.promoteInventoryLocationToDefault?.message ?? 'Successfully updated store!' )
		} else {
			showError( `promoteInventoryLocationToDefaultError${Date.now()}`, result.data?.promoteInventoryLocationToDefault?.message ?? 'Sorry, an error occurred' )
		}
	}
}
